module.exports = __webpack_public_path__ + "assets/img/5.1bbe4483.jpg";